var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledExclamationTriangle24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "008C111E-36E8-413F-A17A-7C4B1E763862") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/exclamation-triangle_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exclamation-triangle",
    transform: "translate(0.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.8199167,12.2225833 C16.3326389,13.1113056 15.6890556,14.2222222 14.665,14.2222222 L1.33483333,14.2222222 C0.308805556,14.2222222 -0.331805556,13.1095833 0.179916667,12.2225833 L6.84508333,0.66625 C7.35805556,-0.222888889 8.64286111,-0.221277778 9.15491667,0.66625 L15.8199167,12.2225833 Z M8,9.83333333 C7.29430556,9.83333333 6.72222222,10.4054167 6.72222222,11.1111111 C6.72222222,11.8168056 7.29430556,12.3888889 8,12.3888889 C8.70569444,12.3888889 9.27777778,11.8168056 9.27777778,11.1111111 C9.27777778,10.4054167 8.70569444,9.83333333 8,9.83333333 Z M6.78686111,5.24038889 L6.99291667,9.01816667 C7.00255556,9.19494444 7.14872222,9.33333333 7.32575,9.33333333 L8.67425,9.33333333 C8.85127778,9.33333333 8.99744444,9.19494444 9.00708333,9.01816667 L9.21313889,5.24038889 C9.22355556,5.04944444 9.07152778,4.88888889 8.88030556,4.88888889 L7.11966667,4.88888889 C6.92844444,4.88888889 6.77644444,5.04944444 6.78686111,5.24038889 L6.78686111,5.24038889 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledExclamationTriangle24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_exclamation-triangle_24px.54346e11.svg";
export { ForwardRef as ReactComponent };